import styled from 'styled-components';
/**
 * @deprecated Use native scroll instead of this
 */
export const CustomScroll = styled.div `
  min-height: ${({ autoHeight, autoHeightMin }) => autoHeight && autoHeightMin};
  max-height: ${({ autoHeight, autoHeightMax }) => autoHeight && autoHeightMax};
  overflow: auto;
`;
